import React, { useMemo } from "react";

import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";

import { useSingleColumnWidth } from "./Table.context";

import styles from "./TooltipWrapper.module.css";

export interface TooltipWrapperProps {
  children: React.ReactNode;
  tooltipText: string;
  index: number;
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = React.memo(
  /* eslint-disable react/prop-types */
  ({ children, tooltipText, index }) => {
    // TODO: recactor so we do not rely on harcoded 'index' value
    // 'index' prop is used in as marker of particular column, in case of changing column order or hiding columns, this will break

    const columnWidth = useSingleColumnWidth(index);

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const contentWidth = useMemo(() => {
      if (context) {
        context.font = getComputedStyle(document.body).font;
        return context.measureText(tooltipText).width;
      }
      return 0;
    }, [tooltipText, context]);

    const disableTooltip = useMemo(() => {
      return contentWidth < columnWidth;
    }, [contentWidth, columnWidth]);

    return (
      <Tooltip
        tooltipText={tooltipText}
        placement="top"
        disableHoverListener={disableTooltip}
      >
        <div className={styles.wrapper}>{children}</div>
      </Tooltip>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.tooltipText === nextProps.tooltipText &&
      prevProps.index === nextProps.index
    );
  }
);

TooltipWrapper.displayName = "TooltipWrapper";
